import { Component } from 'react'
import './styles.scss'

export class FloatingActionButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick () {
    const { onClick } = this.props
    this.setState(s => ({ active: !s.active }))
    if (onClick) {
      onClick()
    }
  }

  render () {
    const { active: isActive } = this.state
    const { className, title, children } = this.props
    return (
      <div
        aria-hidden='true'
        onClick={this.handleClick}
        className={`btn-floating ${isActive ? 'active' : ''} ${
          className || ''
        }`}
        title={title}
      >
        {children}
      </div>
    )
  }
}
